var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClutch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_406_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 25,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4375 4.375H4.375V30.625H28.4375V4.375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_406_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1296 23.0257C21.7058 24.2506 19.8638 24.9154 17.9632 24.8905C13.5754 24.8905 10.3199 21.7826 10.3199 17.5005C10.3199 13.2186 13.4338 10.2488 17.9632 10.2488C19.8695 10.2426 21.7195 10.8769 23.2003 12.0445L24.1911 12.8042L28.4375 8.72937L27.376 7.76245C24.8064 5.53824 21.4734 4.33086 18.034 4.3783C10.1075 4.3783 4.375 9.90347 4.375 17.4315C4.375 24.9595 10.2491 30.6229 17.9632 30.6229C21.4403 30.6901 24.8106 29.4536 27.376 27.1696L28.4375 26.2718L24.1204 22.1969L23.1296 23.0257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.829 21.9287C18.4274 21.9305 19.0202 21.8172 19.5733 21.5954C20.1265 21.3734 20.6291 21.0473 21.0522 20.6358C21.4753 20.2244 21.8105 19.7355 22.0386 19.1976C22.2667 18.6594 22.3832 18.083 22.3813 17.5009C22.3813 16.6252 22.1145 15.7692 21.6142 15.041C21.114 14.3129 20.403 13.7454 19.5711 13.4103C18.7393 13.0752 17.824 12.9875 16.9409 13.1583C16.0579 13.3292 15.2467 13.7509 14.61 14.3701C13.9734 14.9892 13.5398 15.7782 13.3641 16.6372C13.1885 17.496 13.2786 18.3863 13.6232 19.1954C13.9678 20.0045 14.5512 20.696 15.2998 21.1825C16.0485 21.669 16.9286 21.9287 17.829 21.9287Z",
    fill: "#FF3D2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClutch);
export default __webpack_public_path__ + "static/media/clutch.6fc7598d584f62011fe4484955239d0a.svg";
export { ForwardRef as ReactComponent };